import { type RefinementListItem } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList'
import { useMemo } from 'react'
import { useRefinementList, type UseRefinementListProps, useSearchBox } from 'react-instantsearch'
import { cx } from '@/utils/strings'
import IconFont from '../ui/icon-font'
import { ICONS } from './icons'

export type SearchType = '' | 'pages' | 'help' | 'blog' | 'resources' | 'events' | 'tips' | 'newsfeed'
export const searchTypes: SearchType[] = ['pages', 'help', 'blog', 'resources', 'events', 'tips', 'newsfeed']
export const setType = (type: SearchType, items: RefinementListItem[], refine: any) => {
  const newType = searchTypes.includes(type) ? type : ''
  items.forEach((item) => {
    if (item.isRefined && item.value !== newType) refine(item.value)
    else if (!item.isRefined && item.value === newType) refine(newType)
  })
}

export default function RefinementList(props: UseRefinementListProps) {
  const { items, refine } = useRefinementList(props)
  const { query } = useSearchBox()

  const types = useMemo(
    () => [
      {
        count: items.reduce((sum, item) => sum + item.count, 0),
        value: '',
        label: 'all results',
        isRefined: !items.some((item) => item.isRefined),
      },
      ...searchTypes.map(
        (type) =>
          items.find((item) => item.value === type) || {
            count: 0,
            value: type,
            label: type,
            isRefined: false,
          }
      ),
    ],
    [items]
  )

  return (
    <ul className="list-none flex gap-3 justify-center flex-wrap pt-4 sm:pb-4">
      {query.length > 0 &&
        types?.[0]?.count > 0 &&
        types.map((item, index) => {
          const icon = (ICONS as any)[item.label];
          return (
            <li key={index}>
              <button
                type="button"
                disabled={item.count === 0}
                className={cx(
                  `group px-4 py-1 border text-secondary-500 dark:text-secondary-200 dark:hover:text-secondary-700 rounded-t capitalize
                    sm:border-0 sm:border-b-2
                    hover:bg-secondary-50
                    disabled:pointer-events-none`,
                  item.isRefined && `font-bold text-primaryBlue dark:text-white bg-secondary-100 border-primaryBlue border-2`,
                  item.count === 0 && `text-secondary-200`
                )}
                onClick={() => setType(item.value as SearchType, items, refine)}
              >
                {icon && <IconFont className="leading-4 pr-2" unicode={icon} />}
                {item.label} <small className="text-secondary-300 dark:text-secondary-200 group-hover:text-secondary-300 dark:group-hover:text-secondary-700">({item.count})</small>
              </button>
            </li>
          )
        })
      }
    </ul>
  )
}
